// extracted by mini-css-extract-plugin
export default {"frame":"pageFrame_frame__K4w+a"};